import React from "react";
import { useTranslation } from "react-i18next";

interface Stats {
  whitelist: { total: number; active: number };
  logins: {
    allowed: { last24h: number; last7d: number };
    denied: { last24h: number; last7d: number };
    guest?: { last24h: number; last7d: number };
  };
  accessRequests?: { pending: number };
}

interface Props {
  stats: Stats | null;
}

export function StatsCards({ stats }: Props) {
  const { t } = useTranslation();
  const card = (label: string, value: number | string) => (
    <div className="p-4 rounded-xl border border-border bg-card">
      <div className="text-xs text-muted-foreground uppercase tracking-wide">{label}</div>
      <div className="text-2xl font-semibold text-foreground mt-1">{value}</div>
    </div>
  );

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {card(t("admin.stats.activeCodes"), stats?.whitelist.active ?? "—")}
      {card(t("admin.stats.logins24h"), stats?.logins.allowed.last24h ?? "—")}
      {card(t("admin.stats.pendingRequests"), stats?.accessRequests?.pending ?? "—")}
      {card(
        t("admin.stats.attempts7d"),
        stats ? stats.logins.allowed.last7d + (stats.logins.guest?.last7d ?? 0) + stats.logins.denied.last7d : "—"
      )}
    </div>
  );
}
